var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SearchAssetPropertyRequest_instances, _SearchAssetPropertyRequest_searchAssetPropertyListsRequest, _SearchAssetPropertyRequest_searchAssetModelPropertyListsRequest, _SearchAssetPropertyRequest_handleError;
import { SearchAssetPropertyListsRequest } from './searchAssetPropertyListsRequest';
import { SearchAssetModelPropertyListsRequest } from './searchAssetModelPropertyListsRequest';
export class SearchAssetPropertyRequest {
    constructor(client) {
        _SearchAssetPropertyRequest_instances.add(this);
        _SearchAssetPropertyRequest_searchAssetPropertyListsRequest.set(this, void 0);
        _SearchAssetPropertyRequest_searchAssetModelPropertyListsRequest.set(this, void 0);
        __classPrivateFieldSet(this, _SearchAssetPropertyRequest_searchAssetPropertyListsRequest, new SearchAssetPropertyListsRequest(client), "f");
        __classPrivateFieldSet(this, _SearchAssetPropertyRequest_searchAssetModelPropertyListsRequest, new SearchAssetModelPropertyListsRequest(client), "f");
    }
    async send({ assetPropertyId, assetId, assetModelId, }) {
        try {
            // We need both the asset property and the asset model property to get the complete asset property.
            const assetProperty = await __classPrivateFieldGet(this, _SearchAssetPropertyRequest_searchAssetPropertyListsRequest, "f").send({
                assetPropertyId,
                assetId,
            });
            const assetModelProperty = await __classPrivateFieldGet(this, _SearchAssetPropertyRequest_searchAssetModelPropertyListsRequest, "f").send({
                assetModelPropertyId: assetPropertyId,
                assetModelId,
            });
            if (assetProperty && assetModelProperty) {
                // Asset properties may override asset model properties, so we merge it second.
                const completeAssetProperty = {
                    ...assetModelProperty,
                    ...assetProperty,
                };
                return completeAssetProperty;
            }
        }
        catch (error) {
            __classPrivateFieldGet(this, _SearchAssetPropertyRequest_instances, "m", _SearchAssetPropertyRequest_handleError).call(this, error);
        }
    }
}
_SearchAssetPropertyRequest_searchAssetPropertyListsRequest = new WeakMap(), _SearchAssetPropertyRequest_searchAssetModelPropertyListsRequest = new WeakMap(), _SearchAssetPropertyRequest_instances = new WeakSet(), _SearchAssetPropertyRequest_handleError = function _SearchAssetPropertyRequest_handleError(error) {
    const errorMessage = `Failed to search for asset property. Error: ${error}`;
    console.error(errorMessage);
    throw new Error(errorMessage);
};
